import { gql } from '@apollo/client';

export const GetQuestionnaire = gql`
  query GetQuestionnaireById($id: ID!, $patientId: ID) {
    questionnaire {
      questionnaireById(id: $id, patientId: $patientId) {
        id
        title
        type
        status
        questions {
          id
          text
          metricDefinitionId
          ... on GqlMediaItem {
            title
            note
            media
          }
          metricDefinition {
            id
            title
            id
            components {
              __typename
              scoreType
              code {
                coding {
                  code
                  display
                  version
                  system
                }
                text
              }
              score
              ... on GqlNumericObservationComponent {
                scoreType
                minValue
                maxValue
                value {
                  value
                  unit
                  system
                  code
                }
                scoreConfigV2 {
                  options {
                    id
                    scoreConfig {
                      scoreConditions {
                        id
                        score
                        values {
                          sign
                          value
                        }
                      }
                    }
                    condition {
                      groups {
                        rules {
                          id
                          input {
                            type
                            metricDefinition {
                              id
                              title
                            }
                            metricValueType
                          }
                          predicate {
                            type
                            valueType
                            valueDecimal
                            valueString
                            valueInt
                            valueBoolean
                            valueDatetime
                            valueCodeableConcept {
                              coding {
                                code
                                display
                                version
                                system
                              }
                              text
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              ... on GqlScaleObservationComponent {
                scoreType
                numberOfSteps
                value {
                  value
                  unit
                  system
                  code
                }
                scoreConfigV2 {
                  options {
                    id
                    scoreConfig {
                      scoreConditions {
                        id
                        score
                        values {
                          sign
                          value
                        }
                      }
                    }
                    condition {
                      groups {
                        rules {
                          id
                          input {
                            type
                            metricDefinition {
                              id
                              title
                            }
                            metricValueType
                          }
                          predicate {
                            type
                            valueType
                            valueDecimal
                            valueString
                            valueInt
                            valueBoolean
                            valueDatetime
                            valueCodeableConcept {
                              coding {
                                code
                                display
                                version
                                system
                              }
                              text
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          conditions {
            questionId
            sign
            value
          }
          tip
          scoreVariableName
          code {
            code
            display
            version
            system
          }
          questionType
          isAutoResponseQuestion
          responseValueFormula
          {
              variables
              {
                  key
                  value
                  type
              }
              expression
          }
          ... on GqlNumericQuestion {
            format
            category
            prefillFromMetric
            useScoreFromMetric
            minValue
            maxValue
            scoreConfig {
              scoreConditions {
                id
                score
                values {
                  sign
                  value
                }
              }
            }
            scoreConfigV2 {
              options {
                id
                scoreConfig {
                  scoreConditions {
                    id
                    score
                    values {
                      sign
                      value
                    }
                  }
                }
                condition {
                  groups {
                    rules {
                      id
                      input {
                        type
                        metricDefinition {
                          id
                          title
                        }
                        metricValueType
                      }
                      predicate {
                        type
                        valueType
                        valueDecimal
                        valueString
                        valueInt
                        valueBoolean
                        valueDatetime
                        valueCodeableConcept {
                          coding {
                            code
                            display
                            version
                            system
                          }
                          text
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          ... on GqlScaleQuestion {
            startingPoint
            scaleSteps
            scaleLabels {
              value
              label
            }
            scoreConfig {
              scoreConditions {
                id
                score
                values {
                  sign
                  value
                }
              }
            }
          }
          ... on GqlChoiceQuestion {
            answerOptions {
              id
              score
              coding {
                code
                display
                version
                system
              }
            }
            numberOfChoices
          }
          ... on GqlLikertQuestion {
            questions {
              id
              text
            }
            answerOptions {
              id
              score
              coding {
                display
              }
            }
            allowMultipleResponses
          }
          ... on GqlDateQuestion {
            mode
            includeTime
            expectedDate
            scoreConfig {
              scoreConditions {
                id
                score
                values {
                  sign
                  value
                }
              }
            }
          }
        }
        author {
          id
          firstName
          lastName
        }
        isGlobal
        mainScoreConfig {
          metricDefinitionId
          aggregationStrategy
          scoreDimensions {
            id
            name
            description
            isPrimaryDimension
            interpretationLocalFormula {
              expression
              variables {
                key
                value
                type
                variableType
              }
            }
            scoreType
            code {
              coding {
                code
                display
                version
                system
              }
              text
            }
            scoreConfigV2 {
              options {
                id
                scoreConfig {
                  scoreConditions {
                    id
                    score
                    values {
                      sign
                      value
                    }
                  }
                }
                condition {
                  groups {
                    rules {
                      id
                      input {
                        type
                        metricDefinition {
                          id
                          title
                        }
                        metricValueType
                      }
                      predicate {
                        type
                        valueType
                        valueDecimal
                        valueString
                        valueInt
                        valueBoolean
                        valueDatetime
                        valueCodeableConcept {
                          coding {
                            code
                            display
                            version
                            system
                          }
                          text
                        }
                      }
                    }
                  }
                }
              }
            }
            metricDefinitionId
            metricDefinition {
              id
              title
              components {
                scoreType
                code {
                  coding {
                    code
                  }
                }
              }
            }
          }
          formula {
            expression
            variables {
              key
              value
              type
              variableType
            }
          }
        }
        subScoreConfig {
          id
          title
          metricDefinitionId
          aggregationStrategy
          scoreDimensions {
            id
            name
            description
            isPrimaryDimension
            interpretationLocalFormula {
              expression
              variables {
                key
                value
                type
                variableType
              }
            }
            scoreType
            code {
              coding {
                code
                display
                version
                system
              }
              text
            }
            scoreConfigV2 {
              options {
                id
                scoreConfig {
                  scoreConditions {
                    id
                    score
                    values {
                      sign
                      value
                    }
                  }
                }
                condition {
                  groups {
                    rules {
                      id
                      input {
                        type
                        metricDefinition {
                          id
                          title
                        }
                        metricValueType
                      }
                      predicate {
                        type
                        valueType
                        valueDecimal
                        valueString
                        valueInt
                        valueBoolean
                        valueDatetime
                        valueCodeableConcept {
                          coding {
                            code
                            display
                            version
                            system
                          }
                          text
                        }
                      }
                    }
                  }
                }
              }
            }
            metricDefinitionId
            metricDefinition {
              id
              title
              components {
                scoreType
                code {
                  coding {
                    code
                  }
                }
              }
            }
          }
          formula {
            expression
            variables {
              key
              value
              type
              variableType
            }
          }
        }
        description
        language
        estimatedTimeToFill {
          minutes
          seconds
        }
        categories
        conditionsRelated {
          coding {
            code
            display
            version
            system
          }
          text
        }
        sources {
          author
          title
          journalOfPublishing
          yearOfRelease
          linkToSourceArticle
        }
        isOnboarding
      }
    }
  }
`;
